export enum GameEventCommandKinds {
  doAllInForPlayer = 'doAllInForPlayer',
  doBetForPlayer = 'doBetForPlayer',
  doBuyForPlayer = 'doBuyForPlayer',
  doBuyForAllPlayers = 'doBuyForAllPlayers',
  doCallForPlayer = 'doCallForPlayer',
  doCheckForPlayer = 'doCheckForPlayer',
  doFoldForPlayer = 'doFoldForPlayer',
  doNoActionForPlayer = 'doNoActionForPlayer',
  calculateNextBlinds = 'calculateNextBlinds',
  joinGame = 'joinGame',
  leaveGame = 'leaveGame',
  pauseGame = 'pauseGame',
  resumeGame = 'resumeGame',
  startGame = 'startGame',
  sleepGame = 'sleepGame',
  // testDeadLetterQueue = 'testDeadLetterQueue',
  removePlayerByTeacher = 'removePlayerByTeacher',
  showCardsForTeacher = 'showCardsForTeacher',
  showCardsForEveryone = 'showCardsForEveryone',
  showPlayerCardsForTeacher = 'showPlayerCardsForTeacher',
  showPlayerCardsForEveryone = 'showPlayerCardsForEveryone',
  hideCards = 'hideCards',
  hidePlayerCards = 'hidePlayerCards',
  seatedPlayerByTeacher = 'seatedPlayerByTeacher',
  unseatPlayerByTeacher = 'unseatPlayerByTeacher',
  checkForBots = 'checkForBots',
  setPlayerBuyIn = 'setPlayerBuyIn',
  addBots = 'addBots'
}

// TODO: Include buy?
export type PlayerGameAction =
  | GameEventCommandKinds.doAllInForPlayer
  | GameEventCommandKinds.doBetForPlayer
  | GameEventCommandKinds.doCallForPlayer
  | GameEventCommandKinds.doCheckForPlayer
  | GameEventCommandKinds.doFoldForPlayer
  | GameEventCommandKinds.doBetForPlayer
